import React, {Fragment, useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Animated} from "react-animated-css";
import PageHeaderAtm from "../../../../../atomic/PageHeader/PageHeader";
import {PageTitle} from "../../../../../atomic/PageHeader/PageTitle";
import {WEB_FAQ_LIST} from "../../../../../../constants/appUrls.constants";
import {createFaq, createFaqClearState} from "../../../../../../redux/actions/Web/Faq/faqActions";
import {getLanguages} from "../../../../../../redux/actions/languageActions";
import {isDefined} from "../../../../../../utils";
import {history} from "../../../../../../utils/history";
import faqStyles from "./faqStyles";
import useWebId from "./useWebId";
import FaqForm from "./FaqForm";

export default function CreateFaq() {
    const {t} = useTranslation();
    const classes = faqStyles();
    const dispatch = useDispatch();

    const {propertyWebId, fetching: webIdFetching} = useWebId();

    const createData = useSelector(state => state.faqReducers?.createFaq);
    const createError = useSelector(state => state.faqReducers?.createFaqError);
    const createFetching = useSelector(state => state.faqReducers?.createFaqFetching);

    useEffect(() => {
        dispatch(getLanguages());
        dispatch(createFaqClearState());
    }, [dispatch]);

    useEffect(() => {
        if (isDefined(createData?.status) && createData.status === 200) {
            dispatch(createFaqClearState());
            history.push(WEB_FAQ_LIST);
        }
    }, [createData, dispatch]);

    const handleSubmit = ({faq, action}) => {
        if (!isDefined(propertyWebId)) return;

        dispatch(createFaq({
            property_web_id: propertyWebId,
            action: action,
            faq: faq,
        }));
    };

    return (
        <Fragment>
            <PageTitle title={t('enw-web-faq-create', 'Yeni Soru')}/>
            <PageHeaderAtm
                backButton={WEB_FAQ_LIST}
                exitText={t('enw-web-faq-title_short', 'SSS')}
                text={t('enw-web-faq-create', 'Yeni Soru')}
            />
            <Animated animationIn="fadeIn" animationInDuration={600} isVisible={true}>
                <Container maxWidth="xl">
                    <div className="container-width pb-0 mb-24">
                        {
                            webIdFetching ?
                                <Box className={classes.loadingBox}>
                                    <CircularProgress className={classes.spinner} style={{color: '#d71f26'}}/>
                                </Box>
                                :
                                <FaqForm
                                    initialAction="publish"
                                    saving={createFetching}
                                    errorMessage={createError?.response?.data?.message}
                                    onSubmit={handleSubmit}
                                />
                        }
                    </div>
                </Container>
            </Animated>
        </Fragment>
    );
}
